export const Config = {
    apiUrl: process.env.REACT_APP_API_URL,
    reportPlaybackUrl: process.env.REACT_APP_REPORT_PLAYBACK_URL,
    statisticUrl: process.env.REACT_APP_STATISTIC_URL,
    vastTrackerUrl: 'https://slothmore-ads.farakav.com/vast?clientName=anten',
    gRecaptchaSitekey: '6LerSiAUAAAAAN9BnLSTuuaN9mIUO7T6mvbQlKOt',
    primaryColor: '#eb3a64',
    locale: 'fa',
    lengthCode: 5,
    resendVerificationCodeTimeout: 60,
    productionTip: false,
    showRelatedPrograms: false,
    thirdPartyCredentials: {
        googleAnalytics: 'UA-97890887-11',
        hotjar: {
            id: 1050196,
            sv: 6
        }
    },
    VASTEnabled: true,
    VASTURL: ['https://vast-ads.farakav.com/anten.xml', 'https://vast-ads.farakav.com/anten2.xml'],
    appBar: {
        addToHomeScreen: {
            iOS: true,
            android: true
        }
    }
};